<div class="zk-flex zk-flex-col zk-gap-2">
	<cgi-severity
		*ngIf="cgiBaselineAnswer"
		[severity]="cgiBaselineAnswer.selectedOption"
		[type]="cgiBaselineAnswer.type"
		mode="appointment"
	>
	</cgi-severity>
	<vc-history
		mode="appointment"
		[contactId]="contactId"
		[hasBackground]="false"
		[useAccordion]="true"
	></vc-history>
</div>
